<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Filial
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <form id="form">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Nome:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.description"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    CEP:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-mask="'#####-###'"
                                                    v-model="branch.zip_code"
                                                    @keyup="buscar()"
                                                    id="inputCep"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Estado:
                                                </label
                                                >
                                                <input
                                                    autocomplete="new-password"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder=""
                                                    v-model="branch.state"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Cidade:
                                                </label
                                                >
                                                <input
                                                    autocomplete="new-password"
                                                    type="text"
                                                    class="form-control"
                                                    placeholder=""
                                                    v-model="branch.city"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Bairro:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.neighborhood"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Logradouro:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.address"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Número:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.number"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Telefone:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.telephone"
                                                    v-mask="'(##) #####-####'"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label
                                                    for="brand"
                                                >
                                                    <span class="required">*</span>
                                                    Código ERP:
                                                </label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="branch.erp_code"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="block text-right">

                                        <router-link
                                            to="/branches"
                                            class="btn btn-back"
                                        >
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Voltar
                                        </router-link>

                                        <a
                                            class="btn btn-add"
                                            @click="save"
                                        >
                                            Salvar
                                            <i class="fa fa-save ml-2"></i>
                                        </a>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import {getMessage} from "../../composables/message";

export default {
    data() {
        return {
            branch: {
                branch: "",
                address: "",
                telephone: "",
                city: "",
                state: "",
                description: "",
                number: "",
                neighborhood: "",
                zip_code: "",
                erp_code: "",
            },
        };
    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            fd.append("description", self.branch.description);
            fd.append("address", self.branch.address);
            fd.append("number", self.branch.number);
            fd.append("neighborhood", self.branch.neighborhood);
            fd.append("zip_code", self.branch.zip_code);
            fd.append("city", self.branch.city);
            fd.append("state", self.branch.state);
            fd.append("telephone", self.branch.telephone);
            fd.append("erp_code", self.branch.erp_code);

            if (self.branch.id) {
                fd.append("id", self.branch.id);
                fd.append("_method", "PUT");
            }

            return fd;
        },
        save: function () {
            const self = this;
            let api = self.$store.state.api + "branches";

            let fd = self.makeFormData();

            if (self.branch.id) {
                api += "/" + self.branch.id;
            }

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    this.$router.push("/branches");
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        buscar: function () {
            var self = this;

            self.naoLocalizado = false;

            if (/^[0-9]{5}-[0-9]{3}$/.test(this.branch.zip_code)) {
                $.getJSON(
                    "https://viacep.com.br/ws/" + this.branch.zip_code + "/json/",
                    function (endereco) {
                        if (endereco.erro) {
                            self.endereco = {};
                            $("#inputNumero").focus();
                            self.naoLocalizado = true;
                            return;
                        }
                        self.endereco = endereco;
                        self.branch.address = self.endereco.logradouro;
                        self.branch.neighborhood = self.endereco.bairro;
                        self.branch.state = self.endereco.uf;
                        self.branch.city = self.endereco.localidade;
                        $("#inputNumero").focus();
                    }
                );
            }
        },
        getBranch: function (id) {
            const self = this;
            const api = self.$store.state.api + "branches/" + id;

            self.$http
                .get(api)
                .then((response) => {
                    self.branch = response.data.data[0];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },
    mounted: function () {
        const self = this;
        let id = self.$route.params.id;
        if (id) {
            self.getBranch(id);
        }
    },
    components: {
        BaseCrud,
    },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Branches/Add.vue